import DictionaryGlobal from '../../constants/dictionary'
const lenguage = document.documentElement.lang
const Dictionary = DictionaryGlobal[lenguage]
export default Dictionary